type TColor = 'success' | 'info' | 'warning' | 'error';
import {Module} from "vuex";
export interface IMessage{
    message: string;
    color?: TColor;
}
interface IMessageSys extends IMessage{
    key: number;
}
interface IMessageStore{
    storeSuccess:IMessageSys[];
}
export default <Module<IMessageStore, any>>{
    state:{
        storeSuccess:[],
    },
    mutations:{
        removeSuccess(state, i=0){
            if (i < state.storeSuccess.length)
                state.storeSuccess.splice(i, 1);
        },
        addSuccess(state, item:IMessageSys={key:0, message:'', color:'success'}) {
            state.storeSuccess.push(item);
        },
    },
    actions:{
        addSuccess({state, commit}, {message = 'Успешно сохранено!', color = 'success'}:IMessage = <IMessage>{}) {
            const key:number = Math.round((0.5 + Math.random()) * 1000);
            commit('addSuccess', <IMessage>{message, key, color});
            setTimeout(()=>{
                let j = 0;
                const res = state.storeSuccess.find((item, i )=>{
                    j = i;
                    return item.key == key;
                });
                if (res)
                    commit('removeSuccess', j);
            }, 10000);
        }
    },
    getters: {
        storeSuccess: (state):IMessageSys[] => state.storeSuccess,
    },
};
